import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IntroAPI from '../../apis/IntroAPI';
import SubLocation from '../../components/common/SubLocation';
import { EnergyMapList } from '../../models/EnergyMap';
import IntroInfo from '../../models/IntroInfo';
import './EnergyConversionVillage.scss';
import EnergyVillageMapComponent from './EnergyVillageMapComponent';

export const toEnergyMap = (src: IntroInfo): EnergyMapList => ({
  demUid:     src.demUid      ?? src.townId,
  townName:   src.townName,
  area:       src.projectRegion ?? '',
  locInfo:    src.location      ?? '',
  volume:     src.volume        ?? 0,
  centerName: src.centerName    ?? '',
  note:       null,
  centercnt:  null,
  startIndex: null,
  pageSize:   null,
  page:       null,
  lat:        src.lat           ?? 0,
  lng:        src.lng           ?? 0,
});
const highlight = (text: string) => (
  <span style={{ fontWeight: 600, color: '#1d5d9b' }}>{text}</span>
);

/** 구별 요약을 JSX로 반환 */
export function buildSummaryJsx(list: IntroInfo[]): React.ReactNode {
  const guMap: Record<string, string[]> = {
    동구: [], 서구: [], 북구: [], 남구: [], 광산구: [],
  };

  list.forEach((t) => {
    const src = t.projectRegion ?? t.location ?? '';
    const m = src.match(/(동구|서구|북구|남구|광산구)/);
    if (!m) return;
    const gu = m[1] as keyof typeof guMap;
    if (!guMap[gu].includes(t.townName)) guMap[gu].push(t.townName);
  });

  const parts: React.ReactNode[] = [];

  Object.entries(guMap)
    .filter(([, names]) => names.length)
    .forEach(([gu, names], idx, arr) => {
      parts.push(
        <React.Fragment key={gu}>
          {gu}&nbsp;
          {(`${names.length}개소`)}&nbsp;
          {names.map((n, i) => (
            <React.Fragment key={n}>
              {highlight(n)}
              {i < names.length - 1 && ', '}
            </React.Fragment>
          ))}
          {idx < arr.length - 1 && ' • '}
        </React.Fragment>,
      );
    });

  return parts;
}

const SubLocationList = [
    { href: '/platform_02/', text: '소개마당' },
    { href: '/commu_02/', text: '소통마당' },
    { href: '/reward_02/', text: '참여마당' },
    { href: '/info_02/', text: '정보마당' },
];
const SubLocationList2 = [
    { href: '/platform_02/', text: '플랫폼' },
    { href: '/reward_02/mission-main', text: '에너지전환마을' },
];


// 참여마당 > 에너지전환 현황
const EnergyConversionVillage = () => {
    const [villageList, setVillageList] = useState([] as IntroInfo[]);
    const [summary, setSummary] = useState<React.ReactNode>(null);
    const [mapList,    setMapList]        = useState<EnergyMapList[]>([]);
        useEffect(() => {
        IntroAPI.getIntroInfoList().then((res) => {
            const active = res.filter((t: IntroInfo) => t.useYn === 'Y');
            setVillageList(active);
            setMapList(active.map(toEnergyMap));
            setSummary(buildSummaryJsx(active));  
        })
    }, [])

    return (
        <main className="EnergyConversionVillage">
            <h1 className="notext">전체 영역</h1>
            <nav id="lnb">
                <h2 className="notext">네비게이션 영역</h2>
                <SubLocation
                    titleText1="소개마당"
                    liList={SubLocationList}
                    titleText2="에너지전환마을"
                    liList2={SubLocationList2}
                />
                <div className="lnb_txt">
                    <h3>에너지전환마을</h3>
                    <p>에너지전환마을에 대해 함께 알아보아요.</p>
                </div>
            </nav>
            <article id="container">
                <h2 className="notext">컨텐츠 영역</h2>
                {/* 해당 페이지의 시작입니다 */}
                <div id="content" >
                    <div className='villageListDiv'>
                        <MobileList villageList={villageList} />
                        <EnergyVillageMapComponent villageList={mapList} />
                    </div>
                    <h3>에너지전환마을 이란?</h3>
                    <div className='villageInfoListDiv'>
                        <ul className='villageListUl'>
                            <li >
                                <p className='menuTitle'>에너지전환마을은 광주광역시가 지역 시민들의 생활권인 마을에서부터</p>
                                <p>탄소중립 전환 실천을 위해 에너지 공동체 조성 지원 사업에서 시작하였습니다.</p>
                                <p>{summary}</p>
                                <p> 총 <span style={{ fontWeight: '600', color: '#1d5d9b' }}>{villageList.length}</span>개소가 있습니다.</p>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* 해당 페이지의 종료입니다 */}
            </article>
        </main >
    );
};

interface MobileProps {
  villageList: IntroInfo[];
}
const MobileList = ({villageList} : MobileProps) => {
    const navigate = useNavigate();

    const listClick = (townId: number) => {
        navigate(`/commu_02/mainVillage_03`);
        sessionStorage.setItem('town', String(townId));
    }
    return (
        <div className='mobileVillListDiv'>
            <ul className='mobileVillListUl'>
                {villageList.map((list, index) => (
                    <>
                        <li key={index} onClick={() => listClick(list.townId)}>{`${list.townName}`}
                            <p>{`${list.centerName == null ? '센터정보 없음' : list.centerName}`}</p>
                        </li>
                    </>
                ))}
            </ul>
        </div>
    );
}
export default EnergyConversionVillage;
